export default {"src":"/_next/static/image/src/onboarding/BenefitsOverview/free-shipping.091a5cdedcf9b5c531d920d5518436a5.svg","height":62,"width":60};